import Card from '/react4xp/components/prototype/Card'
import Pagination from '/react4xp/components/prototype/Pagination'
import SubpageHero from '/react4xp/components/prototype/SubpageHero'

import type { ReferenceListProps } from './types'

export default function ReferenceList({
	overline,
	heading,
	filters,
	cards,
	currentPage = 1,
	totalPages,
	onPageChange,
	emptyMessage = 'No references match the selected filters.',
}: ReferenceListProps) {
	return (
		<>
			<SubpageHero overline={overline} heading={heading} filters={filters} />

			<section className="my-12">
				<div className="container flex flex-col gap-8">
					{cards.length > 0 ? (
						<>
							<div className="grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-6 lg:grid-cols-3 lg:gap-8">
								{cards.map((card, i) => (
									<Card key={i} {...card} titleSize="h2" />
								))}
							</div>
							<Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />
						</>
					) : (
						<p className="body text-black-950 text-center">{emptyMessage}</p>
					)}
				</div>
			</section>
		</>
	)
}
